import React from 'react';
import { Typography, Modal, Box } from 'bonfire-kindling';
import loadingIcon from 'assets/puff.svg';
import { useTranslation } from 'react-i18next';

const SpinnerModal = ({ open, text }) => {
  const { t } = useTranslation();

  return (
    <Modal open={open} size="small">
      <Box py={8} px={4} display="flex" flexDirection="column" alignItems="center">
        <Typography variant="h1" sx={{ fontSize: '1.5rem', mb: 3 }}>
          {text || t('components.please_wait')}
        </Typography>
        <img alt={t('components.loading_icon')} src={loadingIcon} height="44" width="44" />
      </Box>
    </Modal>
  );
};

export default SpinnerModal;
